import {
  ADD_BORKER_EVENT,
  ADD_BORKER_EVENT_ERROR,
  ADD_BORKER_EVENT_SUCCESS,
  DELETE_BORKER_EVENT,
  DELETE_BORKER_EVENT_ERROR,
  DELETE_BORKER_EVENT_SUCCESS,
  GET_BORKER_EVENT,
  GET_BORKER_EVENT_FAIL,
  GET_BORKER_EVENT_SUCCESS,
  UPDATE_BORKER_EVENT,
  UPDATE_BORKER_EVENT_FAIL,
  UPDATE_BORKER_EVENT_SUCCESS,
} from "./actionTypes"

export const addBrokerEvent = (event, history, callback) => {
  return {
    type: ADD_BORKER_EVENT,
    payload: { event, history, callback },
  }
}

export const addBrokerEventSuccess = event => {
  return {
    type: ADD_BORKER_EVENT_SUCCESS,
    payload: event,
  }
}


export const addBrokerEventError = error => {
  return {
    type: ADD_BORKER_EVENT_ERROR,
    payload: error,
  }
}


export const getBrokerEvent = (brokerId) => ({
  type: GET_BORKER_EVENT,
  brokerId
})

export const getBrokerEventSuccess = events => ({
  type: GET_BORKER_EVENT_SUCCESS,
  payload: events,
})

export const getBrokerEventFail = error => ({
  type: GET_BORKER_EVENT_FAIL,
  payload: error,
})

export const updateBrokerEvent = (event, callback) => ({
  type: UPDATE_BORKER_EVENT,
  payload: { event, callback },
})

export const updateBrokerEventSuccess = event => ({
  type: UPDATE_BORKER_EVENT_SUCCESS,
  payload: event,
})

export const updateBrokerEventFail = error => ({
  type: UPDATE_BORKER_EVENT_FAIL,
  payload: error,
})

export const deleteBrokerEvent = (event, callback) => ({
  type: DELETE_BORKER_EVENT,
  payload: { event, callback },
})

export const deleteBrokerEventSuccess = event => ({
  type: DELETE_BORKER_EVENT_SUCCESS,
  payload: event,
})

export const deleteBrokerEventError = error => ({
  type: DELETE_BORKER_EVENT_ERROR,
  payload: error,
})
